(function () {
  let lastSubmitAttempt = null;
  const targetSubmissionHost = "forms.shopifyapps.com";
  const targetSubmissionKeyword = "form_submission";

  function log() {
    console.log.apply(console, arguments);
  }

  function publishShopifyAnalyticsEvent(eventName, payload) {
    const data = { event: eventName, payload: payload };

    // Shopify analytics bridge -> custom pixels (GTM, etc.)
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(eventName, data);
      log(`Shopify.analytics.publish: ${eventName}`, data);
    } else {
      log("⚠️ Shopify.analytics.publish not available yet.");
    }

    log(`Published Shopify analytics event: ${eventName}`, data);
  }

  function getRequestUrl(resource) {
    if (typeof resource === "string") return resource;
    if (resource && typeof resource.url === "string") return resource.url;
    return "";
  }

  function getRequestMethod(resource, init) {
    const method =
      (init && init.method) ||
      (resource && resource.method) ||
      "";
    return String(method).toUpperCase();
  }

  function isTargetSubmission(resource, init) {
    const url = getRequestUrl(resource);
    if (!url) return false;

    const matchesUrl =
      url.includes(targetSubmissionHost) &&
      url.includes(targetSubmissionKeyword);
    if (!matchesUrl) return false;

    const method = getRequestMethod(resource, init);
    if (!method) return true;
    if (method === "OPTIONS") return false;
    return method === "POST";
  }

  function emitSubmitOutcome(eventName, status) {
    const payload = lastSubmitAttempt || {
      id: null,
      name: null,
      method: null,
      action: null,
      timestamp: new Date().toISOString()
    };

    console.log(`[dev] ${eventName} detected`, {
      status: status,
      ...payload
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      status: status,
      form_id: payload.id,
      form_name: payload.name,
      form_method: payload.method,
      form_action: payload.action,
      form_timestamp: payload.timestamp
    });

    if (eventName === "form_submit_success") {
      publishShopifyAnalyticsEvent("form_submit_headrest", {
        source: "shopify_forms",
        status: status,
        form_id: payload.id,
        form_name: payload.name,
        form_method: payload.method,
        form_action: payload.action,
        form_timestamp: payload.timestamp
      });
    }
  }

  function installSubmissionNetworkHook() {
    if (window.__formsSubmissionHookInstalled) return;
    window.__formsSubmissionHookInstalled = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch === "function") {
      window.fetch = function (resource, init) {
        const shouldTrack = isTargetSubmission(resource, init);

        return originalFetch.apply(this, arguments).then(
          function (response) {
            if (shouldTrack) {
              if (response.status >= 200 && response.status < 300) {
                emitSubmitOutcome("form_submit_success", response.status);
              } else {
                emitSubmitOutcome("form_submit_failed", response.status);
              }
            }
            return response;
          },
          function (error) {
            if (shouldTrack) {
              emitSubmitOutcome("form_submit_failed", 0);
            }
            throw error;
          }
        );
      };
    }

    const xhrOpen = XMLHttpRequest.prototype.open;
    const xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fsMethod = method;
      this.__fsUrl = url;
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      const fakeResource = { method: this.__fsMethod, url: String(this.__fsUrl || "") };
      const shouldTrack = isTargetSubmission(fakeResource);

      if (shouldTrack) {
        this.addEventListener("load", () => {
          if (this.status >= 200 && this.status < 300) {
            emitSubmitOutcome("form_submit_success", this.status);
          } else {
            emitSubmitOutcome("form_submit_failed", this.status);
          }
        });
        this.addEventListener("error", () => emitSubmitOutcome("form_submit_failed", 0));
        this.addEventListener("abort", () => emitSubmitOutcome("form_submit_failed", 0));
        this.addEventListener("timeout", () => emitSubmitOutcome("form_submit_failed", 0));
      }

      return xhrSend.apply(this, arguments);
    };
  }

  function installOmnisendSubmitListener() {
    if (window.__omnisendSubmitListenerInstalled) return;
    window.__omnisendSubmitListenerInstalled = true;
    let lastProcessedKey = "";
    let lastProcessedAt = 0;

    function onOmnisendFormsEvent(event) {
      const detail = event && event.detail ? event.detail : null;
      if (!detail) return;

      const rawEventType =
        detail.type ||
        detail.eventName ||
        detail.event ||
        "";
      const eventType = String(rawEventType).toLowerCase();
      if (eventType !== "submit") return;

      const payload = {
        id: detail.form && detail.form.id ? detail.form.id : null,
        name: detail.form && detail.form.name ? detail.form.name : null,
        timestamp: new Date().toISOString()
      };

      const dedupeKey = `${eventType}:${payload.id || ""}:${payload.name || ""}:${Math.floor(event.timeStamp || 0)}`;
      const now = Date.now();
      if (dedupeKey === lastProcessedKey && now - lastProcessedAt < 1000) return;
      lastProcessedKey = dedupeKey;
      lastProcessedAt = now;

      console.log("[dev] omnisend_form_submit_success detected", payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "omnisend_form_submit_success",
        omnisend_event_type: eventType,
        omnisend_form_id: payload.id,
        omnisend_form_name: payload.name,
        omnisend_timestamp: payload.timestamp
      });

      publishShopifyAnalyticsEvent("form_submit_sauna", {
        source: "omnisend",
        omnisend_event_type: eventType,
        omnisend_form_id: payload.id,
        omnisend_form_name: payload.name,
        omnisend_timestamp: payload.timestamp
      });
    }

    window.addEventListener("omnisendForms", onOmnisendFormsEvent, true);
    document.addEventListener("omnisendForms", onOmnisendFormsEvent, true);
  }

  function initCountryObserver() {
    const boundForms = new WeakSet();

    const meta = document.querySelector('meta[name="current-domain"]');
    const domainValue = meta ? meta.content.trim() : "";
    const parts = domainValue.split(".");
    const tld = parts[parts.length - 1].toUpperCase();

    const escapedSelector = "#custom\\#country";


    // --------------------------------
    // UNIVERSAL INPUT SEARCH (Shadow-safe)
    // --------------------------------
    function searchIn(root) {
      try {
        const found = root.querySelector(escapedSelector);
        if (found) return found;
      } catch (_) {}

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
      let node = walker.currentNode;

      while (node) {
        if (node.shadowRoot) {
          const inside = searchIn(node.shadowRoot);
          if (inside) return inside;
        }
        node = walker.nextNode();
      }
      return null;
    }


    // --------------------------------
    // CORRECT FIELD WRAPPER (Shopify Forms)
    // --------------------------------
    function findWrapper(field) {
      // Shopify Forms ALWAYS wraps inputs in:
      // <div class="_formFieldContainer_1mxsl_5 ">
      return field.closest("div._formFieldContainer_1mxsl_5");
    }

    function bindSubmitListener(field) {
      const form = field.closest("form");
      if (!form || boundForms.has(form)) return;

      form.addEventListener("submit", function () {
        const payload = {
          id: form.id || null,
          name: form.getAttribute("name") || null,
          method: (form.getAttribute("method") || "GET").toUpperCase(),
          action: form.getAttribute("action") || "",
          timestamp: new Date().toISOString()
        };

        lastSubmitAttempt = payload;

        console.log("[dev] form_submit_attempt detected", payload);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_submit_attempt",
          form_id: payload.id,
          form_name: payload.name,
          form_method: payload.method,
          form_action: payload.action,
          form_timestamp: payload.timestamp
        });
      }, true);

      boundForms.add(form);
    }


    // --------------------------------
    // APPLY VALUE + HIDE WRAPPER
    // --------------------------------
    function applyValue() {
      const field = searchIn(document);
      if (!field) return false;

      bindSubmitListener(field);

      field.value = tld;

      field.dispatchEvent(new Event("input",  { bubbles: true, composed: true }));
      field.dispatchEvent(new Event("change", { bubbles: true, composed: true }));

      const wrapper = findWrapper(field);
      if (wrapper) {
        wrapper.style.display = "none";
      }

      return true;
    }


    // Retry for Safari popup delays
    let attempts = 0;
    const interval = setInterval(() => {
      if (applyValue() || attempts++ > 40) clearInterval(interval);
    }, 100);


    // MutationObserver for inline + popup
    const obs = new MutationObserver(() => applyValue());
    obs.observe(document, { childList: true, subtree: true });

    applyValue();
  }

  installSubmissionNetworkHook();
  installOmnisendSubmitListener();
  window.addEventListener("load", initCountryObserver);

})();
